import { Tooltip } from "radix-ui";
import { twMerge } from "tailwind-merge";

export const TooltipComponent = (props: Tooltip.TooltipProps) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root {...props} />
    </Tooltip.Provider>
  );
};

const Content = ({
  className,
  children,
  ...props
}: Tooltip.TooltipContentProps) => {
  return (
    <Tooltip.Portal>
      <Tooltip.Content
        className={twMerge(
          "text-balticSea flex flex-col rounded-md bg-white px-3 py-2 text-xs font-medium shadow-lg",
          className
        )}
        sideOffset={4}
        {...props}
      >
        {children}

        <Tooltip.Arrow className="fill-white" />
      </Tooltip.Content>
    </Tooltip.Portal>
  );
};

const Trigger = (props: Tooltip.TooltipTriggerProps) => {
  return <Tooltip.Trigger {...props} />;
};

TooltipComponent.Trigger = Trigger;
TooltipComponent.Content = Content;
